module.exports = __webpack_public_path__ + "static-portal/img/map-yyy.872f9c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-yyy.png
// module id = zon3
// module chunks = 4